import axios from "axios";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons";
const AddMemberModal = ({ isOpen, setModal, onClose, groupData }) => {
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [people, setPeople] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to handle dropdown visibility
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch all members of the group
        const groupResponse = await axios.get(
          `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/members/${groupData.groupid}`,
          {
            headers: {
              Authorization: `Bearer ${user.idToken}`,
            },
          }
        );
  
        // Fetch all friends
        const friendsResponse = await axios.get(
          `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/friends/GetAllFriends`,
          {
            headers: {
              Authorization: `Bearer ${user.idToken}`,
            },
          }
        );
  
        // Extract data from responses
        const groupMembers = groupResponse.data;
        const allFriends = friendsResponse.data;
        console.log('groupMembers', groupMembers);
        console.log('allFriends', allFriends);
  
        // Filter out friends who are not in the group
        const filteredFriends = allFriends.filter(
          friend => !groupMembers.some(member => member.email === friend.email)
        );
  
        // Set the filtered friends to state
        setPeople(filteredFriends);
        console.log(people);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    // Call the fetch function
    fetchData();
  }, [isOpen, user.idToken, groupData.groupid]);
  const handleSaveExpense = async () => {
    if(selectedPeople.length==0){
      onClose();
    }
    const payload = {
      Requests: selectedPeople.map((item) => ({
        gid: groupData.groupid,
        memberId:item.email
      }))
    }
    try {
      const res = await axios.post(
        "https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/insertMultiple",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.idToken}`,
          },
        }
      );
      alert("User added successfully");
    } catch (error) {
      alert(error);
    }
    setSelectedPeople([])
    onClose();
  };

  const handleCheckboxChange = (person, isChecked) => {
    if (isChecked) {
      setSelectedPeople([...selectedPeople, person]);
    } else {
      setSelectedPeople(selectedPeople.filter((p) => p !== person));
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed w-full h-full top-0 left-0 z-10  inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <div className="w-full inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full h-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4  w-full">
                    <button
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)} // Toggle dropdown visibility
                      className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                      type="button"
                    >
                      Select People
                      <FontAwesomeIcon icon={faCaretDown} />
                    </button>

                    {/* Dropdown menu */}
                    {isDropdownOpen && (
                      <div className="z-10 w-full bg-white rounded-lg shadow dark:bg-white-100">
                        <ul className="p-3 space-y-1 text-sm text-black-900 dark:text-black-900">
                          {people.map(person => (
                            <li key={person.email}>
                              <div className="flex items-center p-2 rounded hover:bg-gray-100 dark:hover:bg-green-600">
                                <input
                                  id={`checkbox-item-${person.email}`}
                                  type="checkbox"
                                  value={person.email}
                                  className="w-4 h-4 text-green-600 bg-white-100 border-gray-300 rounded focus:ring-green-500 dark:focus:ring-green-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  onChange={(e) => handleCheckboxChange(person, e.target.checked)}
                                />
                                <label htmlFor={`checkbox-item-${person.email}`} className="w-full ms-2 text-sm font-medium text-black-900 m-1 rounded dark:text-black-300">
                                  {person.name}
                                </label>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 m-5 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => handleSaveExpense()}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => {
                    setModal(false);
                    setSelectedPeople([]);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddMemberModal;
